const jsonToFormData = (json) => {
  const formData = new FormData();
  try {
    for (let key in json) {
      if (json[key] instanceof Array) {
        json[key].forEach((jsonObject) => {
          formData.append(key, jsonObject);
        });
      } else {
        formData.append(key, json[key]);
      }
    }
    return formData;
  } catch (e) {
    return formData;
  }
};

export { jsonToFormData };
